import { GET_SNACKBAR, GET_IS_LOADING } from "../action/dataAction";

const initState = {
  snackbar: {
    open: false,
    content: "",
    severity: "success",
    isLoading: false,
  },
};

const dataReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_SNACKBAR:
      return {
        ...state,
        snackbar: action.payload.snackbar,
      };

    case GET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };

    default:
      break;
  }

  return state;
};

export default dataReducer;
